import React from "react";
import Logo from "../../assets/svg/mawaloglogo.svg";
const PoweredBy = ({ marginTop = "0px", paddingBottom = "10px" }) => {
  return (
    <div
      className="GTWalsheimTrial"
      style={{
        textAlign: "center",
        marginTop,
        paddingBottom,
        paddingTop: "10px",
        fontWeight: "400",
        fontSize: "12px",
        color: "#172B4D",
        backgroundColor: "transparent",
      }}
    >
      Powered by{" "}
      <span>
        <img
          src={Logo}
          alt="Logo"
          style={{ height: "16px", verticalAlign: "middle", cursor: "pointer" }}
          onClick={() => {
            window.open("https://mawalog.com/", "_blank", "noopener,noreferrer");
          }}
        />
      </span>
    </div>
  );
};

export default PoweredBy;
